module.exports = "<div class=\"loading\"><div class=\"loader\"></div></div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/loading/loading.component.html
// module id = ../../../../../src/app/shared/loading/loading.component.html
// module chunks = 2